export default __webpack_public_path__ + "static/media/Old-Ochre.660d52b0.jpg";